import { add, qs } from "@fluorescent/dom";

const selectors = {
  productReviewsSummary: ".spr-summary",
  productReviewsCaption: ".spr-summary-caption",
  productReviewsStarrating: ".spr-summary-starrating",
};

export default function (reviews, rating) {
  if (!reviews.length) return;

  let reviewsLoaded = false;

  // Allow for actions after Shopify Product Reviews loads
  window.SPRCallbacks = {};
  window.SPRCallbacks.onReviewsLoad = () => {
    if (reviewsLoaded) return;

    // Add rating number to Shopify Product Reviews summary
    const productRatingFormatted = parseFloat(rating).toFixed(1);

    if (productRatingFormatted && !isNaN(productRatingFormatted)) {
      const captionGroupDiv = document.createElement("div");
      const ratingDiv = document.createElement("div");
      ratingDiv.textContent = productRatingFormatted;
      add(captionGroupDiv, "spr-summary-caption-group");
      add(ratingDiv, "spr-summary-rating");

      reviews.forEach(instance => {
        const reviewsSummary = qs(selectors.productReviewsSummary, instance);
        const reviewsCaption = qs(selectors.productReviewsCaption, instance);
        const reviewsStarrating = qs(
          selectors.productReviewsStarrating,
          instance
        );
        captionGroupDiv.prepend(reviewsCaption);
        captionGroupDiv.prepend(reviewsStarrating);
        reviewsSummary.prepend(captionGroupDiv);
        reviewsSummary.prepend(ratingDiv);
      });

      reviewsLoaded = true;
    }
  };
}
